module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/bm-7dd1b92ad42d2f9d69dd785acff5c8da.svg";